export const TEST_PAYLOAD = {
  guilds: [
    {
      guild: {
        id: 1047044,
        name: 'Echo',
        faction: 'horde',
        realm: {
          id: 719,
          connectedRealmId: 300,
          name: 'Tarren Mill',
          altName: null,
          slug: 'tarren-mill',
          altSlug: 'tarren-mill',
          locale: 'en_GB',
          isConnected: true
        },
        region: {
          name: 'Europe',
          slug: 'eu',
          short_name: 'EU'
        },
        path: '/guilds/eu/tarren-mill/Echo',
        logo: 'https://cdn.raiderio.net/images/rwf/sepulcher-of-the-first-ones/echo/guildlogo.png',
        color: '#cd1d2d'
      },
      raid: {
        difficulty: 'mythic',
        name: 'Sepulcher of the First Ones',
        short_name: 'SFO',
        slug: 'sepulcher-of-the-first-ones',
        expansion_id: 8
      },
      bosses: [
        {
          boss: {
            encounterId: 180773,
            name: 'Vigilant Guardian',
            slug: 'vigilant-guardian',
            ordinal: 0,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/vigilant-guardian.jpg'
          },
          bestPercent: 0,
          pullCount: 13,
          pullStartedAt: '2022-07-13T18:06:54.858Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 183937,
            name: 'Skolex',
            slug: 'skolex',
            ordinal: 1,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/skolex.jpg'
          },
          bestPercent: 0,
          pullCount: 15,
          pullStartedAt: '2022-07-13T20:16:14.926Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 183501,
            name: "Artificer Xy'mox",
            slug: 'artificer-xymox',
            ordinal: 2,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/artificer-xymox.jpg'
          },
          bestPercent: 0,
          pullCount: 20,
          pullStartedAt: '2022-07-13T20:22:35.125Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181224,
            name: 'Dausegne',
            slug: 'dausegne',
            ordinal: 3,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/dausegne.jpg'
          },
          bestPercent: 0,
          pullCount: 24,
          pullStartedAt: '2022-07-25T17:17:02.018Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181549,
            name: 'Prototype Pantheon',
            slug: 'prototype-pantheon',
            ordinal: 4,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/prototype-pantheon.jpg'
          },
          bestPercent: 0,
          pullCount: 39,
          pullStartedAt: '2022-07-25T17:26:13.391Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 182169,
            name: 'Lihuvim',
            slug: 'lihuvim',
            ordinal: 5,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/lihuvim.jpg'
          },
          bestPercent: 0,
          pullCount: 35,
          pullStartedAt: '2022-07-13T20:59:05.194Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 184915,
            name: 'Halondrus',
            slug: 'halondrus',
            ordinal: 6,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/halondrus.jpg'
          },
          bestPercent: 0,
          pullCount: 389,
          pullStartedAt: '2022-07-13T20:32:28.342Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181954,
            name: 'Anduin Wrynn',
            slug: 'anduin-wrynn',
            ordinal: 7,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/anduin-wrynn.jpg'
          },
          bestPercent: 0,
          pullCount: 176,
          pullStartedAt: '2022-07-13T18:18:16.542Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 26533,
            name: 'Lords of Dread',
            slug: 'lords-of-dread',
            ordinal: 8,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/lords-of-dread.jpg'
          },
          bestPercent: 0,
          pullCount: 73,
          pullStartedAt: '2022-07-13T18:32:46.734Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 182777,
            name: 'Rygelon',
            slug: 'rygelon',
            ordinal: 9,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/rygelon.jpg'
          },
          bestPercent: 0,
          pullCount: 198,
          pullStartedAt: '2022-07-13T18:44:27.732Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 185421,
            name: 'The Jailer',
            slug: 'the-jailer',
            ordinal: 10,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/the-jailer.jpg'
          },
          bestPercent: 0,
          pullCount: 295,
          pullStartedAt: '2022-07-25T17:00:38.733Z',
          isDefeated: 1
        }
      ]
    },
    {
      guild: {
        id: 1712677,
        name: 'Liquid',
        faction: 'horde',
        realm: {
          id: 369,
          connectedRealmId: 207,
          name: 'Illidan',
          altName: null,
          slug: 'illidan',
          altSlug: 'illidan',
          locale: 'en_US',
          isConnected: false
        },
        region: {
          name: 'United States & Oceania',
          slug: 'us',
          short_name: 'US'
        },
        path: '/guilds/us/illidan/Liquid',
        logo: 'https://cdn.raiderio.net/images/rwf/sepulcher-of-the-first-ones/liquid/guildlogo.png',
        color: '#ffffff'
      },
      raid: {
        difficulty: 'mythic',
        name: 'Sepulcher of the First Ones',
        short_name: 'SFO',
        slug: 'sepulcher-of-the-first-ones',
        expansion_id: 8
      },
      bosses: [
        {
          boss: {
            encounterId: 180773,
            name: 'Vigilant Guardian',
            slug: 'vigilant-guardian',
            ordinal: 0,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/vigilant-guardian.jpg'
          },
          bestPercent: 0,
          pullCount: 8,
          pullStartedAt: '2022-07-05T21:41:27.997Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 183937,
            name: 'Skolex',
            slug: 'skolex',
            ordinal: 1,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/skolex.jpg'
          },
          bestPercent: 0,
          pullCount: 10,
          pullStartedAt: '2022-07-05T22:40:30.112Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 183501,
            name: "Artificer Xy'mox",
            slug: 'artificer-xymox',
            ordinal: 2,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/artificer-xymox.jpg'
          },
          bestPercent: 0,
          pullCount: 32,
          pullStartedAt: '2022-07-05T22:57:34.005Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181224,
            name: 'Dausegne',
            slug: 'dausegne',
            ordinal: 3,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/dausegne.jpg'
          },
          bestPercent: 0,
          pullCount: 14,
          pullStartedAt: '2022-07-05T21:51:37.216Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181549,
            name: 'Prototype Pantheon',
            slug: 'prototype-pantheon',
            ordinal: 4,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/prototype-pantheon.jpg'
          },
          bestPercent: 0,
          pullCount: 46,
          pullStartedAt: '2022-07-05T22:02:27.160Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 182169,
            name: 'Lihuvim',
            slug: 'lihuvim',
            ordinal: 5,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/lihuvim.jpg'
          },
          bestPercent: 0,
          pullCount: 59,
          pullStartedAt: '2022-07-05T22:25:37.997Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 184915,
            name: 'Halondrus',
            slug: 'halondrus',
            ordinal: 6,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/halondrus.jpg'
          },
          bestPercent: 0,
          pullCount: 358,
          pullStartedAt: '2022-07-05T23:11:01.181Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 181954,
            name: 'Anduin Wrynn',
            slug: 'anduin-wrynn',
            ordinal: 7,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/anduin-wrynn.jpg'
          },
          bestPercent: 0,
          pullCount: 257,
          pullStartedAt: '2022-07-05T23:43:50.945Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 26533,
            name: 'Lords of Dread',
            slug: 'lords-of-dread',
            ordinal: 8,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/lords-of-dread.jpg'
          },
          bestPercent: 0,
          pullCount: 88,
          pullStartedAt: '2022-07-06T00:12:37.001Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 182777,
            name: 'Rygelon',
            slug: 'rygelon',
            ordinal: 9,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/rygelon.jpg'
          },
          bestPercent: 0,
          pullCount: 259,
          pullStartedAt: '2022-07-06T00:36:30.390Z',
          isDefeated: 1
        },
        {
          boss: {
            encounterId: 185421,
            name: 'The Jailer',
            slug: 'the-jailer',
            ordinal: 10,
            wingId: 0,
            iconUrl: '/images/sepulcher-of-the-first-ones/bossicons/the-jailer.jpg'
          },
          bestPercent: 0,
          pullCount: 384,
          pullStartedAt: '2022-07-12T22:14:49.495Z',
          isDefeated: 1
        }
      ]
    }
  ],
  numEncounters: 11
};
